import React, { Component } from 'react';
import './Form.css';
import ProgressBar from 'react-bootstrap/ProgressBar';
import PlacesAutocomplete from 'react-places-autocomplete';
import Rating  from 'react-rating';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/fr';

const URL_CONFIG = "https://config.mercigustave.co";

const slotsFrToEn = [
  {Fr:'7h',En:'7:00am'},
  {Fr:'8h',En:'8:00am'},
  {Fr:'9h',En:'9:00am'},
  {Fr:'10h',En:'10:00am'},
  {Fr:'11h',En:'11:00am'},
  {Fr:'12h',En:'12:00pm'},
  {Fr:'13h',En:'1:00pm'},
  {Fr:'14h',En:'2:00pm'},
  {Fr:'15h',En:'3:00pm'},
  {Fr:'16h',En:'4:00pm'},
  {Fr:'17h',En:'5:00pm'},
  {Fr:'18h',En:'6:00pm'},
  {Fr:'19h',En:'7:00pm'},
  {Fr:'20h',En:'8:00pm'},
  {Fr:'21h',En:'9:00pm'},
  {Fr:'22h',En:'10:00pm'},
  {Fr:'23h',En:'11:00pm'}
];

let TXTS_FILE = null;
let gustaveJson = null;
let hostJson = null;
let plageSelect = "";
let formatDeliveryDate = 'DD-MM-YYYY';
let lang = "FR";

let firstReturnDelayHour = 2;
let lastReturnDelayHour = 2;
let returnHourRange = 2;
let returnHourDelay = 1;
let returnDaysDelay = 2;
let returnNextDayOpen = true;

let deliveryDaysArray = [];
let deliverySlotsArray = [];

let autoSelectDay = null;


let villesOk = [];
(async function() {
  TXTS_FILE = await getTxtJson("prod");
  TXTS_FILE = TXTS_FILE? TXTS_FILE.data : null;
  gustaveJson = await getGustaveJson("prod");
  gustaveJson = gustaveJson.data;
  firstReturnDelayHour = gustaveJson.firstReturnDelayHour;
  lastReturnDelayHour = gustaveJson.lastReturnDelayHour;
  returnHourRange = gustaveJson.returnHourRange;
  returnHourDelay = gustaveJson.returnHourDelay;
  returnDaysDelay = gustaveJson.returnDaysDelay;
  returnNextDayOpen = gustaveJson.returnNextDayOpen;
  villesOk = gustaveJson.villes;
})();

let currentDate = moment();

const searchOptions = {
  componentRestrictions: { country: "fr" }
};

let adresseComplete = "";
let autoSuggGoogleMaps = true;
let villeSelect = false;
let villeTest = false;
let content = {
  Fr:{
    steps: {
      email: { quest: 'Quelle est votre adresse mail ? *', emptyInputErr: 'Veuillez mentionner votre adresse mail.', invalidErr: 'Aucun essayage planifié pour cette adresse mail !', planifiedErr: 'Oups ! Vous avez déja planifié votre retour !', formatErr: 'Veullez entrer un email valide', soonErr: 'Merci de revenir quand votre essayage aura commencé !' },
      takeall: { quest: 'Gardez vous tous les aticles ? *', emptyInputErr:''},
      heure: { quest: 'Quand pouvons-nous récupérer ce que vous ne souhaitez pas garder ? *', emptyInputErr: 'Veuillez mentionner l\'heure pour votre retour.', invalidErr: "Veuillez entrer une heure valide pour votre retour :)", toLateErr: "Il n'est plus possible de planifier votre retour :(" },
      adresse: { quest: 'À quelle adresse ?*', emptyInputErr: 'Veuillez mentionner l\'adresse de retour.', invalidErr: "Oups, cette adresse n'est pas valide", toFarErr: "Oups, cette ville n'est pas encore desservie ;)" },
      statTry: { quest: 'Avez-vous commandé grâce au service d\'essayage ?', btns: ["Oui", "Non"] },
      note: { quest: 'Comment noteriez-vous votre essayage avec Gustave ?*', emptyInputErr: 'Veuillez noter notre service.' },
      returnedProduct: { quest: 'Quels articles souhaitez-vous rendre  ? *', infosExchange: 'Votre message :',emptyInputErr: 'Veuillez faire un choix pour chaque article.' }
    },
    startText: "Merci d'avoir fait confiance à Gustave pour vos essayages 👌",
    placeHolder: {
      email: 'Entrez votre email',
      adresse: 'Entrez une adresse pour votre retour.. *',
      complement: {
        desktop: "Infos complémentaires, code, interphone, étage, etc..",
        mobile: "Infos complémentaires.."
      },
      remarque:{
        desktop: 'Une remarque ? Une suggestion ? Laissez-nous votre avis ! ',
        mobile: 'Une remarque ?'
      }
    },
    command: 'Commande',
    loading: 'Recherche en cours..',
    takeAll: 'Je souhaite tout garder',
    notTakeAll: 'Je souhaite faire un retour',
    mailContact: 'Nous contacter',
    color: 'Couleur ',
    taille: 'Taille ',
    prix: 'Prix ',
    quantity: 'Quantité ',
    garder: 'Garder',
    rendre: 'Rendre',
    echanger: 'Échanger',
    suivant: 'Suivant',
    passer: 'Passer',
    endText: {
      text1:'Merci pour votre confiance et à très vite pour de nouveaux essayages 💃',
      text2: {part1:'Votre retour a bien été planifié. Un coursier passera chez vous*entre ', part2: 'et', part3: 'au'},
      text3: 'Foncez découvrir toutes nos marques partenaires sur',
    },
    popUp: {
      text: 'Merci de bien vouloir noter notre service avant de valider.',
    },
    popUp3: {
      titre: "Vous souhaitez échanger un ou plusieurs articles ?",
      text1: "1. Veuillez nous indiquer ce que vous souhaitez échanger :",
      text2: "2. Choisissez un créneau pour rendre les articles que vous souhaitez rendre et/ou échanger.",
      text3: "3. Notre service client vous recontactera au plus vite !",
      button: "J'ai compris !",
    },
    valider: 'Valider',
    progressBar: {text2: 'étape', text1:'sur'},
    popUp2: {text:'Veuillez choisir une commande.'},
    todayLabel: 'Aujourd\'hui',
    tomorrowLabel: 'Demain',
    noMoreSlot: "Il n'est plus possible de choisir un créneau pour ce jour."
  },
  En:{
    steps: {
      email: { quest: 'What is you email address? *', emptyInputErr: 'Please mention your email adress.', invalidErr: 'No fitting planned for this email address!', planifiedErr: 'Oops, you have already planned a return!', formatErr: 'Please enter a valid email', soonErr: 'Please come back when your fitting has started!' },
      takeall: { quest: 'What items would you like to keep? *', emptyInputErr: '' },
      heure: { quest: 'What time do you want to return?*', emptyInputErr: 'Please specify a timeslot for your return.', invalidErr: "Please enter a valid timeslot for your return :)", toLateErr: "It's no longer possible to schedule a return :(" },
      adresse: { quest: 'Which address?*', emptyInputErr: 'Please mention your adress for your return.', invalidErr: "Oops, the adress is incorrect", toFarErr: "Oops, this city is not served yet ;)" },
      statTry: { quest: 'Did you order through the fitting service?', btns: ["Yes", "No"] },
      note: { quest: 'Kindly give a rate to our service before confirming!*', emptyInputErr: 'Please, give a rate to our service before confirming' },
      returnedProduct: { quest: 'Which items do you want to return? *', infosExchange: 'Your message :', emptyInputErr: 'Please make a choice for each item.' }
    },
    startText: "Thank you for trusting Gustave for your online shopping 👌",
    placeHolder: {
      email: 'Please enter your email address',
      adresse:'Enter an adress for your return. *',
      complement: {
        desktop: "Additional info, code, intercom, floor, etc..",
        mobile: "Additional info.."
      },
      remarque: {
        desktop: 'Any observation? suggestion? Please leave us your opinion! ! ',
        mobile: 'Any suggestion ?'
      }
    },
    command: 'Order',
    loading: 'Loading',
    takeAll: 'I want to keep everything',
    notTakeAll: 'I wish to plan a return',
    mailContact: 'Contact us',
    color: 'Color',
    taille: 'Size',
    prix: 'Price',
    quantity: 'Quantity',
    garder: 'Keep',
    rendre: 'Return',
    echanger: 'Exchange',
    suivant: 'Next',
    passer: 'Pass',
    endText: {
      text1: 'Thank you for your trust and see you soon for new fittings 💃',
      text2: {part1:'Your return has been planned. A courier will come*between ', part2: 'and', part3: 'at'},
      text3: 'Do not hesitate to discover all our partner brands on',
    },
    popUp: {
      text:'Kindly give a rate to our service before confirming ',
    },
    popUp3: {
      titre: "Do you want to exchange one or more articles?",
      text1: "1. Please tell us what you want to exchange :",
      text2: "2. Please choose a valid timeslot for the items you want to return and/or exchange.",
      text3: "3. Our customer service will contact you as soon as possible !",
      button: "I understood !",
    },
    valider: 'Confirm',
    progressBar: { text2:'step', text1:'of' },
    popUp2: {text: 'Please choose an order.'},
    todayLabel: 'Today',
    tomorrowLabel: 'Tomorrow',
    noMoreSlot: "It is no longer possible to choose a time slot for this day."
  }

};

let refresh = false;
let counterLive = 0;

const initState = {
  enableForm: true,
  steps: {
    email: { quest: 'Quelle est votre adresse mail ? *', rep: null, errMsg: null },
    takeall: { quest: 'Gardez vous tous les aticles ? *', rep: null, errMsg: null },
    returnedProduct: { quest: 'Quels articles souhaitez-vous rendre ou échanger ? *', rep: [], errMsg: null },
    exchangeProduct: { rep: [], infos: "" },
    heure: { quest: 'À quelle heure souhaitez-vous effectuer votre retour ? Aujourd’hui, entre…*', rep: null, errMsg: null },
    adresse: { quest: 'À quelle adresse ?*', rep: null, errMsg: null },
    statTry: { quest: 'Avez-vous commandé grâce au service d\'essayage ?', btns: ["Oui", "Non"] },
    note: { quest: 'Comment noteriez-vous votre essayage avec Gustave ?*', rep: null, errMsg: null }
  },
  stepNum: "start",
  takeAll: null,
  mailChange: '',
  adresseChange: null,
  counter: 0,
  totalQuestions: 0,
  flecheOn: false,
  produits: null,
  complement: '',
  note: null,
  remarque: null,
  keepedProduct: [],
  env: "null",
  commands: [],
  selectedCommand: 0,
  command: null,
  command_id: null,
  loading: false,
  language: 'Fr',
  currentContent: content.Fr,
  mailValid: false,
  repStatTry: null,
  selectedPopup: null,
  shopify_mode: false,
  retourExchange: false,
  selectedDay: null,
  selectedSlot: null,
  returnSlots: []
};

function getTxtJson(mode) {
  return axios.get(URL_CONFIG + "?type=jsons&mode=" + mode + "&name=txts_return_form.json");
}

function getGustaveJson(mode) {
  return axios.get(URL_CONFIG + "?type=jsons&mode=" + mode + "&name=gustave.json");
}

function isDayOff(jour, closedDays, date, marque) {
	let closed = false;

  if (ifDisposDays(date, marque)) { // test si fermeture boutique

    if (gustaveJson && gustaveJson.indispos && gustaveJson.indispos.length > 1) { // si pas fermée, test si indispos Gustave
			for (let day of gustaveJson.indispos) {
				if (date === day.date && day.heures.length === 0) {
          //console.log("indisponibilité du service Gustave");
          closed = true;
				}
			}
		}

		if (!closed) { // si Gustave dispo, test jours closed boutique
      for (let data of closedDays){
        if (jour === data.day && data.heures.length === 0) closed = true;
      }
		}

  } else closed = true; // Si fermeture boutique

	//console.log("jour testé : " + jour + " - date : " + date + " - closed : " + closed);

	return closed;
}

function ifDisposDays(date, marque) {
	let dispo = true;
	if(marque && marque.indispos && marque.indispos.start) {
		//cl(" test fermeture boutique ");
		let startDate = marque.indispos.start;
		let endDate = marque.indispos.end;

		let formatedDeliveryDate = moment(date.split("-")[2] + "-" + date.split("-")[1] + "-" +date.split("-")[0]);
		let formatedHostStartDate = moment(startDate.split("-")[2] + "-" + startDate.split("-")[1] + "-" +startDate.split("-")[0]);
		let formatedHostEndDate = moment(endDate.split("-")[2] + "-" + endDate.split("-")[1] + "-" + endDate.split("-")[0]);

		let diffStart = formatedDeliveryDate.diff(formatedHostStartDate, "days");
		let diffEnd = formatedDeliveryDate.diff(formatedHostEndDate, "days");

		if(diffStart >= 0 && diffEnd <= 0) {
			dispo = false;
		}
	}
	return dispo;
}

class Form extends Component {

  constructor(props) {
    super(props);
    this.state = initState;
  }

  componentDidMount = () => {
		let email;
    document.addEventListener("keydown", this.handleKeyDown);
    document.querySelector('.formContainer').style.minHeight = '90vh';

    if (window.location.search.substring(1)) {
      let query = decodeURI(window.location.search.substring(1));
      query = atob(query);

			if (query.indexOf("email=") !== -1) {
				email = query.split("email=")[1];
				email = email.indexOf("&") !== -1? email.split("&")[0] : email;
				email = email.indexOf("#") !== -1? email.split("#")[0] : email;
				email = (email.indexOf("@") !== -1 && email.split(".")[email.split(".").length-1].length >= 2 && email.split(".")[email.split(".").length-1].length <= 5)? email : null;
			}
			//console.log("email : " + email);
		}

    if (sessionStorage.getItem("saveState")) {
      refresh = true;
      this.setState({...initState, mailChange: email? email : ''}, () => {
        if (this.state.mailChange) this.handleMailSubmit();
      });
    } else this.setState({...initState, mailChange: email? email : ''}, () => {
      if (this.state.mailChange) this.handleMailSubmit();
    });
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    document.querySelector('.formContainer').style.minHeight = '90vh';
    if(prevState !== this.state) {
      //sessionStorage.setItem("saveState", JSON.stringify(this.state));
      sessionStorage.setItem("saveState", JSON.stringify(initState));
    }
    if(prevState.selectedCommand !== this.state.selectedCommand) {
      this.setState({selectedCommand: this.state.selectedCommand});
    }
    if(prevState.stepNum !== this.state.stepNum) {
      this.setState({stepNum: this.state.stepNum}, () => {
      });
    }
    if(prevState.takeAll !== this.state.takeAll) {
      this.setState({takeAll: this.state.takeAll});
    }
    if(prevState.note !== this.state.note) {
      this.setState({note: this.state.note});
    }
    if(prevState.selectedPopup !== this.state.selectedPopup) {
      this.setState({selectedPopup: this.state.selectedPopup}, () => {
        if (this.state.selectedPopup && window.location.href.search('#popup') === -1) {
          //console.log("did update => openPopup : " + this.state.selectedPopup);
          this.openPopup(this.state.selectedPopup);
        } else if (!this.state.selectedPopup && window.location.href.search('#popup') !== -1) {
          //console.log("did update => closePopup");
          this.closePopup();
        }
      });
    }

    if(refresh) {
      refresh = false;
      this.activeClassForProducts(this.state.produits, this.state.steps, this.state.keepedProduct);
    }
    this.updateStatusBtnFooter();
  }

  returnSlotEn(slotFr) {
    const slotFound = slotsFrToEn.find(slot => slot.Fr === slotFr);
    const slotEn = slotFound? slotFound.En : slotFr;
    return slotEn;
  }

  buildDeliveryDays = (date, heure, returnDate, step) => {
    currentDate = moment();
    autoSelectDay = null;
    deliveryDaysArray = [];
    if (returnDaysDelay !== gustaveJson.returnDaysDelay) returnDaysDelay = gustaveJson.returnDaysDelay;

    const formatedDate = date.split("-")[2] + "-" + date.split("-")[1] + "-" + date.split("-")[0] + "T" + (+heure.split("h - ")[0] > 9? heure.split("h - ")[0] : "0" + heure.split("h - ")[0]) + ":00:00";

    const formatedLastDate = date.split("-")[2] + "-" + date.split("-")[1] + "-" + date.split("-")[0] + "T23:59:59";

    const commandMoment = moment(formatedDate);
    const lastPlanMoment = moment(formatedLastDate);
    const lastReturnMoment = moment(formatedDate.split("T")[0] + "T23:59:59").add(returnDaysDelay, 'days');
    let currentDelay = currentDate.diff(lastPlanMoment, 'minutes');
    //console.log("date d'essayage : " + commandMoment.format('LLLL') + "\ndernier retour possible : " + lastReturnMoment.format('LLLL') + "\nlimite planification possible : " + lastPlanMoment.format('LLLL') + "\ndate du jour : " + currentDate.format('LLLL'));

    let returnDateMoment = null;
    if (currentDelay >= 0 && returnDate) {
      const lastHourForSlots = Math.floor(hostJson.openHours.end) - lastReturnDelayHour;
      //console.log("lastHourForSlots : " + lastHourForSlots);

      const formatedReturnDate = returnDate.split("-")[2] + "-" + returnDate.split("-")[1] + "-" + returnDate.split("-")[0] + "T" + (lastHourForSlots > 9? lastHourForSlots : "0" + lastHourForSlots) + ":00:00";
      returnDateMoment = moment(formatedReturnDate);
      currentDelay = currentDate.diff(returnDateMoment, 'minutes');
      //console.log("date de retour exceptionnel : " + returnDateMoment.format('LLLL'));
    }

    if (currentDelay >= 0) {
      // délai retour dépassé
      //console.log("délai pour retour dépassé - delai en minutes : " + currentDelay);
      this.handleTooLate();

    } else {
      if (!returnDateMoment) {
        //returnDateMoment = lastReturnMoment;

        //console.log("délai retour restant en minutes : " + currentDelay);
        for (let m = commandMoment; m.diff(lastReturnMoment, 'minutes') <= 0; m.add(1, 'days')) {

          if (currentDate.diff(m, 'days') > 0) {
            // jour dépassé
            //console.log("jour dépassé : " + m.format('DD-MM-YYYY'));

          } else {
            if (m.locale() !== 'fr') m.locale('fr');
            const jourFr = m.format('dddd');
            const momentDay = moment(m.format());
            if (m.locale() !== lang.toLowerCase()) m.locale(lang.toLowerCase());

            const closed = isDayOff(jourFr, hostJson.closed, m.format(formatDeliveryDate), hostJson);
            const slots = this.slotsInit(m);

            if (!closed && slots.length) {
              deliveryDaysArray.push({
                moment: momentDay,
                date: m.format(formatDeliveryDate),
                label: m.format(formatDeliveryDate) === moment().format(formatDeliveryDate)? content[lang === "FR"? "Fr" : "En"].todayLabel : m.format(formatDeliveryDate) === moment().add(1,'days').format(formatDeliveryDate)? content[lang === "FR"? "Fr" : "En"].tomorrowLabel : m.format('ddd D MMM'),
                jour: jourFr,
                slots: slots
              });
            } else if (closed && returnNextDayOpen && !returnDate) lastReturnMoment.add(1, 'days');
          }
        }
      } else {
        if (returnDateMoment.locale() !== 'fr') returnDateMoment.locale('fr');
        const jourFr = returnDateMoment.format('dddd');
        const momentDay = moment(returnDateMoment.format());
        if (returnDateMoment.locale() !== lang.toLowerCase()) returnDateMoment.locale(lang.toLowerCase());

        const closed = isDayOff(jourFr, hostJson.closed, returnDateMoment.format(formatDeliveryDate), hostJson);
        const slots = this.slotsInit(returnDateMoment);

        if (!closed && slots.length) {
          deliveryDaysArray.push({
            moment: momentDay,
            date: returnDateMoment.format(formatDeliveryDate),
            label: returnDateMoment.format(formatDeliveryDate) === moment().format(formatDeliveryDate)? content[lang === "FR"? "Fr" : "En"].todayLabel : returnDateMoment.format(formatDeliveryDate) === moment().add(1,'days').format(formatDeliveryDate)? content[lang === "FR"? "Fr" : "En"].tomorrowLabel : returnDateMoment.format('ddd D MMM'),
            jour: jourFr,
            slots: slots
          });
        } else {
          // délai retour exceptionnel dépassé
          //console.log("délai pour retour exceptionnel dépassé");
          this.handleTooLate();
        }
      }

      autoSelectDay = deliveryDaysArray.length? deliveryDaysArray[0].date : null;
      //console.log("deliveryDaysArray :\n", deliveryDaysArray, "\nautoSelectDay : " + autoSelectDay);

      if (autoSelectDay) {
        //console.log("jour dispo - autoSelectDay : " + autoSelectDay);
        this.setState({selectedDay: autoSelectDay, returnSlots: deliveryDaysArray[0].slots}, () => {
          this.handleNext(step);
        });
      } else {
        //console.log("pas de jour dispo");
      }
    }
  }

  buildDeliverySlotsArray = (start, end, range, date, heure, returnDate, step) => {
    //console.log("start : " + start + " - end : " + end + " - range : " + range);
    deliverySlotsArray = [];

    for (let i = start; i <= end; i++) {
      if (i <= end) {
        const slotFrStart = i + "h";
        const slotFrEnd = (i + range) + "h";
        const slot = {
          Fr: slotFrStart + " - " + slotFrEnd,
          En: this.returnSlotEn(slotFrStart) + " - " + this.returnSlotEn(slotFrEnd)
        };
        //console.log(slot);
        deliverySlotsArray.push(slot);
      }
    }
    //console.log("deliverySlotsArray:\n", deliverySlotsArray);

    this.buildDeliveryDays(date, heure, returnDate, step);
  }

  returnNumOfProductsRep() {
    const returnedProduct = this.state.steps.returnedProduct.rep;
    const keepedProduct = this.state.keepedProduct;

    let numOfProductsRep = 0;
    returnedProduct.forEach(returned => {
      if (keepedProduct.findIndex(idKeeped => idKeeped === returned.id) === -1) numOfProductsRep += 1;
    });
    numOfProductsRep += keepedProduct.length;

    //console.log("numOfProductsRep : " + numOfProductsRep/* , keepedProduct, returnedProduct */);
    return numOfProductsRep;
  }

  updateStatusBtnFooter() {
    const state = this.state;
    const btnPrev = document.querySelector('span.prev');
    const btnNext = document.querySelector('span.next');

    if (state.stepNum === "start") {
      off(btnPrev);
      if (state.mailValid) on(btnNext);
      else off(btnNext);

    } else if (state.stepNum === "returnedProduct") {
      on(btnPrev);
      if (this.returnNumOfProductsRep() === state.produits.length) on(btnNext);
      else off(btnNext);

    } else if (state.stepNum === "heure") {
      on(btnPrev);
      if (state.steps.heure.rep) on(btnNext);
      else off(btnNext);

    } else if (state.stepNum === "statTry") {
      if (!state.selectedPopup) {
        on(btnPrev);
        on(btnNext);
      } else {
        on(btnPrev);
        off(btnNext);
      }

    } else if (state.stepNum === "end") {
      off(btnPrev);
      off(btnNext);
    }

    function on(btn) {
      if (btn) {
        btn.style.opacity = 1;
        btn.style.cursor = "pointer";
      }
    }
    function off(btn) {
      if (btn) {
        btn.style.opacity = 0.4;
        btn.style.cursor = "not-allowed";
      }
    }
  }

  handleValidation = () => {
    if (this.state.enableForm) {
      if (this.state.takeAll) { // Si le client garde tout
        this.setState({selectedPopup: null, stepNum: "end", counter: this.countRep("end", this.state.takeAll, null) }, () => {
          this.saveConfirmationRetour();
        });

      } else if (!this.state.takeAll && deliveryDaysArray.length > 0) { // Si retour ou échange et un ou plusieurs créneaux valides
        if (this.valideSlot()) { // Si créneau et jour choisis valides
          this.setState({selectedPopup: null, stepNum: "end", counter: this.countRep("end", this.state.takeAll, null) }, () => {
            this.saveConfirmationRetour();
          });
        } else { // Si créneau choisi plus valide, redirection vers le slide heure
          this.setState({
            steps: { ...this.state.steps,
            heure: { ...this.state.steps.heure, rep: "", errMsg: this.state.currentContent.steps.heure.invalidErr }},
            selectedPopup: null,
            counter: this.countRep(this.state.stepNum, this.state.takeAll, null)
          }, () => {
            this.buildDeliverySlotsArray((Math.round(hostJson.openHours.start) + firstReturnDelayHour), (Math.floor(hostJson.openHours.end) - lastReturnDelayHour), returnHourRange, this.state.command.date, this.state.command.heure, this.state.command.returnDate, "heure");
          });
        }
      } else this.handleTooLate(); // Plus de créneau valide
    }
  }

  valideSlot = () => {
    if (this.state.steps.heure.rep) {
      const deliveryDaySelected = deliveryDaysArray.find(days => days.date === this.state.selectedDay);
      const deliverySlotsForDay = deliveryDaySelected? this.slotsInit(deliveryDaySelected.moment) : [];
      const testSlotIfAvailable = deliverySlotsForDay.length? deliverySlotsForDay.filter(value => value.Fr === this.state.steps.heure.rep).length === 1 : false;
      return testSlotIfAvailable;

    } else return false;
  }

  handlePreviousStep = (e) => {
    const opacity = document.querySelector('span.prev').style.opacity;

    if (opacity === "1") {
      if (this.state.stepNum === "returnedProduct") {
        this.setState({ stepNum: "start", totalQuestions: 0, counter: this.countRep("start", this.state.takeAll, this.state.selectedPopup)});
      } else if (this.state.stepNum === 'heure') {
        this.setState({ stepNum: "returnedProduct", counter: this.countRep("returnedProduct", this.state.takeAll, this.state.selectedPopup) });
      } else if (this.state.stepNum === 'statTry') {
        if (this.state.selectedPopup) {
          this.setState({ selectedPopup: null, counter: this.countRep(this.state.stepNum, this.state.takeAll, null) });
        } else {
          if (this.state.takeAll) this.setState({ stepNum: "start", counter: this.countRep("start", this.state.takeAll, this.state.selectedPopup) });
          else this.setState({ stepNum: "heure", counter: this.countRep("heure", this.state.takeAll, this.state.selectedPopup) });
        }
      }
    }
  }

  handleNextStep = (e) => {
    const opacity = document.querySelector('span.next').style.opacity;
    //console.log("handleNextStep => opacity : " + opacity);

    if (opacity === "1") {
      if (this.state.stepNum === "start") {
        if (this.state.takeAll) this.setState({ stepNum: "statTry", totalQuestions: 3, counter: this.countRep("statTry", this.state.takeAll, this.state.selectedPopup) });
        else this.setState({ stepNum: "returnedProduct", totalQuestions: 5, counter: this.countRep("returnedProduct", this.state.takeAll, this.state.selectedPopup) });

      } else if (this.state.stepNum === 'returnedProduct') {
        this.returnedProductNextScreen();

      } else if (this.state.stepNum === 'heure') {
        this.setState({ stepNum: 'statTry', counter: this.countRep("statTry", this.state.takeAll, this.state.selectedPopup) })

      } else if (this.state.stepNum === 'statTry') {
        this.setState({ selectedPopup: 1, counter: this.countRep(this.state.stepNum, this.state.takeAll, 1) })
      }
    }
  }

  activeClassForProducts = (produits, steps, keepedProduct) => {
    if(this.state.stepNum === "returnedProduct") {
      const returnedProduct = steps.returnedProduct.rep;
      const exchangeProduct = steps.exchangeProduct.rep;

      produits.forEach((art, index) => {
        const searchKeeped = keepedProduct.findIndex(artKeeped => artKeeped === art.id) !== -1;
        const searchReturned = returnedProduct.findIndex(artReturned => artReturned.id === art.id) !== -1;
        const searchExchange = exchangeProduct.findIndex(artExchange => artExchange === art.id) !== -1;

        if (searchKeeped && !searchReturned) document.querySelector(".cabine #art"+ index + " .garderBtn").classList.add('selected');
        else if (searchReturned) {
          if (searchExchange) document.querySelector(".cabine #art"+ index + " .echangerBtn").classList.add('selected');
          else document.querySelector(".cabine #art"+ index + " .rendreBtn").classList.add('selected');
        }
      });
    }
  }

  returnedProductNextScreen = () => {
    let state = this.state;

    if (state.keepedProduct.length === this.state.produits.length && state.steps.returnedProduct.rep.length === 0) { // Si finalement le client garde tout
      this.setState({
        takeAll: true,
        totalQuestions: 3,
        steps: {
          ...this.state.steps,
          heure: { ...this.state.steps.heure, rep: null, errMsg: null},
          adresse: { ...this.state.steps.adresse, rep: null, errMsg: null },
          note: { ...this.state.steps.note, rep: null, errMsg: null },
          returnedProduct: { ...this.state.steps.returnedProduct, rep: [], errMsg: null },
          exchangeProduct: {...this.state.steps.exchangeProduct, infos: ""}
        },
      }, () => {
        this.handleNext("statTry");
      });

    } else if (state.steps.exchangeProduct.rep.length === this.state.produits.length) { // Si le client souhaite tout échanger
      if (!state.steps.exchangeProduct.infos) this.setState({selectedPopup: 3});
      else this.handleNext("heure");

    } else if (state.steps.returnedProduct.rep.length === this.state.produits.length && state.steps.exchangeProduct.rep.length === 0) { // Si le client retourne tout
      this.setState({
        steps: {...this.state.steps, exchangeProduct: {...this.state.steps.exchangeProduct, infos: ""}}
      }, () => this.handleNext("heure"));

    } else {
      if(state.steps.exchangeProduct.rep.length > 0 && !state.steps.exchangeProduct.infos) this.setState({selectedPopup: 3});
      else {
        if(state.steps.exchangeProduct.rep.length === 0 && state.steps.exchangeProduct.infos) this.setState({
          steps: {...this.state.steps, exchangeProduct: {...this.state.steps.exchangeProduct, infos: ""}}
        }, () => this.handleNext("heure"));
        else this.handleNext("heure");
      }
    }
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter'){
      if (this.state.stepNum === "heure") {
          this.handleNext("statTry");
      } else if (this.state.stepNum === "statTry" && window.location.hash !== "#popup1") {
          this.handleNext("end");
      } else if (window.location.hash === "#popup1") {
          this.handleValidation(null);
      } else if (this.state.stepNum === "returnedProduct") {
        this.returnedProductNextScreen();
      }
    }
  }

  countRep = (stepNum, takeALL, popup) => {
    //console.log("countRep => stepnum : " + stepNum + " - takeALL : " + takeALL + " - popoup1 : " + (popup === 1));
    if(stepNum === "start") counterLive = 0;
    else if(stepNum === "returnedProduct") counterLive = 1;
    else if(stepNum === "heure") counterLive = 2;
    else if(stepNum === "statTry") counterLive = (takeALL? (popup === 1? 2 : 1) : (popup === 1? 4 : 3));
    else if(stepNum === "end") counterLive = (takeALL? (popup === 1? 2 : 3) : (popup === 1? 4 : 5));

    return counterLive;
  }

  saveConfirmationRetour = () => {
    //console.log("saveConfirmationRetour");
    const urlTest = 'https://mercigustave-node-test.herokuapp.com/retourrequest';
    const urlProd = 'https://mercigustave-node.herokuapp.com/retourrequest';

    let retour = {
      email: this.state.steps.email.rep.toLowerCase(),
      keepedProduct: this.state.keepedProduct,
      note: this.state.note
    };

    if (this.state.remarque) retour.remarque = this.state.remarque;
    if (this.state.repStatTry) retour.repStatTry = this.state.repStatTry;

    if (!this.state.takeAll) {
      retour.returnedProduct = this.state.steps.returnedProduct.rep;
      retour.exchangeProduct = {
        products: this.state.steps.exchangeProduct.rep,
        infos: this.state.steps.exchangeProduct.infos
      };
      retour.date = this.state.selectedDay;
      retour.heure = this.state.steps.heure.rep;
      retour.adresse = this.state.steps.adresse.rep;
      retour.complement = this.state.complement;
    }

    //console.log(retour);
    sessionStorage.removeItem("saveState");

    return fetch((this.state.env === "test"? urlTest : urlProd), {
      method: 'POST',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: this.state.retourExchange? JSON.stringify({ retourExchange: retour, command_id: this.state.command_id }) : JSON.stringify({ retour: retour, command_id: this.state.command_id })
    }).then(response => {
      //console.log("ok", response);
      this.setState({enableForm: false});
    }, error => {
      //console.log(error)
    });
  }

  handleTooLate = () => {
    sessionStorage.removeItem("saveState");
    let steps = this.state.steps;
    this.setState({
      stepNum: "start",
      steps: { ...steps,
      email: { ...steps.email, rep: null, errMsg: this.state.currentContent.steps.heure.toLateErr },
      heure: { ...steps.heure, rep: null, errMsg: this.state.currentContent.steps.heure.toLateErr },
      adresse: { ...steps.adresse, rep: null, errMsg: this.state.currentContent.steps.heure.toLateErr },
      returnedProduct: {...steps.returnedProduct, rep: [], errMsg: this.state.currentContent.steps.heure.toLateErr} },
      totalQuestions: 0,
      counter: 0
    }, () => {
      document.querySelector('button.takeALL.btn').disabled = true;
      document.querySelector('button.takeALL.btn').classList.add("disabled-btn");
      document.querySelector('button.notTakeAll.btn').disabled = true;
      document.querySelector('button.notTakeAll.btn').classList.add("disabled-btn");
      off(document.querySelector('span.prev'));
      off(document.querySelector('span.next'));

      //document.querySelector('button.contact.btn').disabled = false;
      document.querySelector('button.contact.btn').classList.remove("disabled-btn");

      function off(btn) {
        if (btn) {
          btn.style.opacity = 0.4;
          btn.style.cursor = "not-allowed";
        }
      }
    });
  }

  valideAdresse = (value) => {

    adresseComplete = value;
    if (value.split(", ").length >= 3) { // utilise google maps
      let villeAdresse = value.split(", ")[value.split(", ").length - 2];

      if (villeAdresse.split(" ").length >= 2 && villeAdresse.split(" ")[0].match(/([0-9]{5})/g)) {
        let codePostal = +villeAdresse.split(" ")[0];

        if (codePostal >= 75000 && codePostal < 76000) { // si Paris
          villeSelect = true;
        } else { // sinon
          for (let ville of villesOk) {
            if (codePostal === ville.cp) {
              villeSelect = true;
              break;
            } else villeSelect = false;
          }
        }
      } else {
        for (let ville of villesOk) {
          if (villeAdresse === ville.nom) {
            villeSelect = true;
            break;
          } else villeSelect = false;
        }
      }
      villeTest = true;
    } else if (value.split(" ").length >= 2) { // saisie manuelle (avec code postal ou ville)
      let codePostal = "";
      let adresse = value.split(" ");
      for (let data of adresse) {
        if (data.match(/([0-9]{5})/g)) {
          codePostal = +data;
          break;
        } else if (data.length > 2) {
          for (let ville of villesOk) {
            if (data.toLowerCase() === ville.nom.toLowerCase()) {
              villeSelect = true;
              break;
            } else villeSelect = false;
          }
        }
      }

      if (codePostal !== "" && codePostal >= 75000 && codePostal < 76000) { // si Paris
        villeSelect = true;
      } else if (codePostal !== "") { // sinon
        for (let ville of villesOk) {
          if (codePostal === ville.cp) {
            villeSelect = true;
            break;
          } else villeSelect = false;
        }
      }
      villeTest = true;
    } else if (value !== "" && value.length > 5) { // saisie manuelle sans code postal
      villeTest = false;
      villeSelect = true;
    } else {
      villeTest = false;
      villeSelect = false;
    }
  }

  openPopup = (num) => {
    window.location = '#popup' + num;
  }

  closePopup = () => {
    window.location = '#';
  }

  validateEmail = (email) => {
    if (email !== "" && email !== null && email !== null) {
			var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  updateForm = async (command) => {
    //console.log("updateForm => command", command);
    const that = this;
    let steps = this.state.steps;
    lang = command.lang;

    if (command.mode && command.mode === "test") {
      TXTS_FILE = null;
      TXTS_FILE = await getTxtJson("test");
      TXTS_FILE = TXTS_FILE? TXTS_FILE.data : null;
      gustaveJson = await getGustaveJson("test");
      gustaveJson = gustaveJson.data;
      //console.log("gustaveJson for test :", gustaveJson, TXTS_FILE);
      firstReturnDelayHour = gustaveJson.firstReturnDelayHour;
      lastReturnDelayHour = gustaveJson.lastReturnDelayHour;
      returnHourRange = gustaveJson.returnHourRange;
      returnHourDelay = gustaveJson.returnHourDelay;
      returnDaysDelay = gustaveJson.returnDaysDelay;
      returnNextDayOpen = gustaveJson.returnNextDayOpen;
      villesOk = gustaveJson.villes;
    }

    if (TXTS_FILE && TXTS_FILE.Fr && TXTS_FILE.En) content = TXTS_FILE;

    let updateState = {
      loading: false,
      mailValid: true,
      command: command,
      command_id: command._id,
      retourExchange: command.retour && (command.token === 'accepted' || command.token === 'trying')? true : false,
      shopify_mode: command.shopify,
      keepedProduct: this.state.takeAll? command.data.filter(article => article.status !== false) : [],
      produits: this.state.produits? this.state.produits : JSON.parse(sessionStorage.getItem('produitsRef')),
      adresseChange: command.adresse,
      complement: command.complement? command.complement : '',
      steps: {
        ...steps, adresse: { ...steps.adresse, rep: command.adresse, errMsg: null },
        email: { ...steps.email, errMsg: null, rep: this.state.mailChange },
        returnedProduct: { ...steps.returnedProduct, rep: [] }
      }
    };

    if (command.lang === "EN") {
      updateState.language = 'En';
      updateState.currentContent = content.En;

    } else updateState.currentContent = content.Fr;

    if (this.state.selectedPopup) updateState.selectedPopup = null;

    this.setState(updateState, () => {
      if (this.state.takeAll) this.setState({ stepNum: "statTry", counter: this.countRep("statTry", this.state.takeAll, null), totalQuestions: 3});
      else {
        const xhrHost = new XMLHttpRequest();
        xhrHost.onreadystatechange = function () {
          if (xhrHost.readyState === 4) {
            if (xhrHost.status === 200) {
              hostJson = JSON.parse(xhrHost.responseText);
              //console.log("hostJson :", hostJson);
              that.buildDeliverySlotsArray((Math.round(hostJson.openHours.start) + firstReturnDelayHour), (Math.floor(hostJson.openHours.end) - lastReturnDelayHour), returnHourRange, command.date, command.heure, command.returnDate, "returnedProduct");
            } else {
              //console.log("erreur " + command.host + ".json", xhrHost.responseText);
            }
          }
        }
        xhrHost.open( 'GET', URL_CONFIG + "?type=jsons&mode=" + command.mode + "&name=" + command.host + ".json");
        xhrHost.setRequestHeader('Accept', 'text/html');
        xhrHost.send(null);
      }
    });
  }

  handleMailSubmit = () => { //
    //console.log("handleMailSubmit");
    const steps = this.state.steps;
    let email = this.state.mailChange.replace(/ /g, "");

    if (this.validateEmail(email)) {
      this.setState({ loading: true }, () => {
        currentDate = moment().format('DD-MM-YYYY');
        const urlTest = 'https://mercigustave-node-test.herokuapp.com/apitest/allcommands/"email":"' + email.toLowerCase() + '"';
        const urlProd = 'https://mercigustave-node.herokuapp.com/api/allcommands/"email":"' + email.toLowerCase() + '"';

        this.findCommand(urlTest) // Recherche dans les commandes test
        .then(commandTestFound => {
          const dateNow = moment().format('DD-MM-YYYY');
          const heureNow = moment().format('H');
          let soon = null;

          //console.log("commandes test", commandTestFound);
          if (commandTestFound && commandTestFound.length > 0) {
            soon = commandTestFound.find(command => command.token === 'accepted');

            commandTestFound = commandTestFound.filter(command => ((command.date === dateNow || command.returnDate === dateNow) && (heureNow >= (+command.heure.split("h -")[0])) && (command.token === 'accepted' || command.token === 'trying')));
          }

          if (commandTestFound.length > 0) { // Si une ou plusieurs commandes trouvées
            this.checkCommand(commandTestFound, "test");

          } else if (!soon) {

            // Recherche dans les commandes prod
            this.findCommand(urlProd)
            .then(commandProdFound => {
              //console.log("commandes prod", commandProdFound);
              if (commandProdFound && commandProdFound.length > 0) {
                soon = commandProdFound.find(command => command.token === 'accepted');

                commandProdFound = commandProdFound.filter(command => ((command.date === dateNow || command.returnDate === dateNow) && (heureNow >= (+command.heure.split("h -")[0])) && (command.token === 'accepted' || command.token === 'trying')));
              }

              if (commandProdFound.length > 0) { // Si une ou plusieurs commandes trouvées
                this.checkCommand(commandProdFound, "prod");

              } else { // Si aucune commande trouvée
                this.setState({
                  loading:false,
                  mailValid:false,
                  steps: { ...steps, email: { ...steps.email, errMsg: soon? this.state.currentContent.steps.email.soonErr : this.state.currentContent.steps.email.invalidErr } }
                });
              }
            })
            .catch(error => {
                //console.log("erreur findCommand in prod", error)
                this.setState({
                  loading:false,
                  mailValid:false,
                  steps: { ...steps, email: { ...steps.email, errMsg: this.state.currentContent.steps.email.invalidErr } }
                });
            });
          } else {
            this.setState({
              loading:false,
              mailValid:false,
              steps: { ...steps, email: { ...steps.email, errMsg: soon? this.state.currentContent.steps.email.soonErr : this.state.currentContent.steps.email.soonErr } }
            });
          }
        })
        .catch(error => {
          //console.log("erreur findCommand in test", error)
        });
      });

    } else {
      this.setState({
        mailValid: false,
        steps: { ...steps, email: { ...steps.email, errMsg: this.state.currentContent.steps.email.formatErr } }
      });
    }
  }

  findCommand = (url) => {
    return new Promise ((resolve, reject) => {
      axios.get(url)
      .then(data => {
        if (data && data.data) resolve(data.data);
        else reject(data);
      })
      .catch(error => reject(error));
    });
  }

  checkCommand = (commandsFound, mode) => {
    if (commandsFound.length > 0) { // Si une ou plusieurs commandes éligibles non retournées
      if (commandsFound.length === 1) {
        sessionStorage.setItem('produitsRef', JSON.stringify(commandsFound[0].data.filter(article => article.status !== false)));
        this.setState({
          env: mode
        }, () => this.updateForm(commandsFound[0])); // Si commande non retournée

      } else if (commandsFound.length > 1) { // Si plusieurs commandes non retournées

        this.setState({
          selectedCommand: 0,
          commands: commandsFound,
          env: mode,
        }, () => this.setState({selectedPopup: 2}));
      }
    } else { // si retour déjà planifié
      this.setState({
        loading: false,
        mailValid: false,
        steps: { ...this.state.steps, email: { ...this.state.steps.email, errMsg: this.state.currentContent.steps.email.planifiedErr, rep: null} }
      });
    }
  }

  handleDateChange = (e, n) => {
    //console.log("handleDateChange - heure : " + e);
    plageSelect = e;

    let heureFR;
    if (this.state.language === "En") {
      heureFR = deliverySlotsArray.filter(value => value.En === e)[0].Fr;
      //console.log("heureFR : " + heureFR);
    } else heureFR = e;


    let steps = this.state.steps;

    if (e && e !== "") {
      this.setState({ steps: { ...steps, heure: { ...steps.heure, rep: heureFR, errMsg: null } } })
    } else if (!e || e === ""){
      this.setState({ steps: { ...steps, heure: { ...steps.heure, rep: null, errMsg: this.state.currentContent.steps.heure.toLateErr } } })
    } else {
      this.setState({ ...this.state.steps.heure, errMsg: this.state.currentContent.steps.heure.invalidErr })
      this.setState({ steps: { ...steps, heure: { ...steps.heure, rep: null, errMsg: this.state.currentContent.steps.heure.invalidErr } } })
    }
  }

  handleAdresseChange = (e) =>{
    this.setState({adresseChange: e})
    let steps = this.state.steps
    this.valideAdresse(e)
    if (adresseComplete !== "" && villeSelect) {
      this.setState({ steps: { ...steps, adresse: { ...steps.adresse, rep: e, errMsg: null } } })
    } else if (adresseComplete !== "" && !villeSelect && villeTest){
      this.setState({ steps: { ...steps, adresse: { ...steps.adresse, rep: null, errMsg: this.state.currentContent.steps.adresse.toFarErr } } })
    }else{
      this.setState({ steps: { ...steps, adresse: { ...steps.adresse, rep: null, errMsg: this.state.currentContent.steps.adresse.invalidErr } } })
    }
  }

  handleRateChange = (e) =>{
    if (e) {
      this.setState({ note: e })
    } else {
      this.setState({ note: null })
    }
  }

  handleNext = (next) => {
    //console.log("handleNext : " + next);
    let steps = this.state.steps;

    if (!this.state.takeAll) { // Si le client souhaite rendre ou échanger un ou plusieurs articles

      if (deliveryDaysArray.length > 0) { // Si au moins un slot dispo

        // Si step returnedProduct ou step heure, sélection automatique du 1er slot dispo
        if (next === "returnedProduct" || next === "heure") {
          plageSelect = this.state.returnSlots[0][this.state.language];
          //console.log("plageSelect auto : " + plageSelect);
          this.setState({ stepNum: next, totalQuestions: this.state.takeAll? 3 : 5, counter: this.countRep(next, this.state.takeAll, this.state.selectedPopup), steps : { ...steps, heure: { ...steps.heure, rep: this.state.returnSlots[0].Fr, errMsg: null} } });

        } else { // sinon test du slot sélectionné et redirection au step heure si plus dispo

          if (this.valideSlot() || this.state.stepNum === "returnedProduct") {

            if (next === "end") this.setState({selectedPopup: 1, counter: this.countRep(next, this.state.takeAll, 1)});
            else this.setState({ stepNum: next, totalQuestions: this.state.takeAll? 3 : 5, counter: this.countRep(next, this.state.takeAll, this.state.selectedPopup),
              steps: { ...steps, heure: { ...steps.heure, errMsg: null }}
            });

          } else this.setState({
            stepNum: "heure",
            counter: this.countRep("heure", this.state.takeAll, this.state.selectedPopup),
            steps: { ...steps,
            heure: { ...steps.heure, rep: this.state.returnSlots[0].Fr, errMsg: this.state.currentContent.steps.heure.invalidErr }}
          });
        }

      } else this.handleTooLate();

    } else { // Si le client souhaite tout garder
      if (next === "end") this.setState({selectedPopup: 1, counter: this.countRep(this.state.stepNum, this.state.takeAll, 1)});
      else this.setState({ stepNum: next, counter: this.countRep(next, this.state.takeAll, this.state.selectedPopup) });
    }
  }

  handleTakeAll = (takeALL) => {
    //console.log('handleTakeAll => takeALL : ' + takeALL);
    this.setState({takeAll: takeALL}, () => this.handleMailSubmit());
  }

  handleContactUs = () => {
    window.open('mailto:hello@mercigustave.co', '_self');
  }

  handleBtnMouseOn = (e) => {
    if(e==="all")
      document.querySelector(".all").style.visibility = 'visible'
    else
      document.querySelector(".notall").style.visibility = 'visible'
  }

  handleBtnMouseOut = (e) => {
    if (e === "all") document.querySelector(".all").style.visibility = 'hidden';
    else document.querySelector(".notall").style.visibility = 'hidden';
  }

  removePlagesIndispos(momentTested, deliverySlotsArray) {
    if (momentTested.locale() !== 'fr') momentTested.locale('fr');
    const jourFr = momentTested.format('dddd');
    const dayPlages = hostJson.closed.find(value => (value.day === jourFr && value.heures.length));
    let slots = deliverySlotsArray;

    if (dayPlages) {
      //console.log("plages indispos pour " + jourFr, dayPlages.heures);

      for (let plageIndispo of dayPlages.heures) {
        let slotsTemp = slots;
        slots = slots.filter(value => value.Fr !== plageIndispo);

        if (slots.length === slotsTemp.length) {
          //console.log("removePlagesIndispos => plage (large) : " + plageIndispo);//, "\nslots de base :\n", slots);
          const plageIndispoOn = +plageIndispo.split("h - ")[0];
          const plageIndispoOff = +plageIndispo.split("h - ")[1].replace("h", "");

          slots = slots.filter(value => {
            const heureOn = +value.Fr.split("h - ")[0];
            const heureOff = +value.Fr.split("h - ")[1].replace("h", "");

            //console.log("plageIndispo : de " + plageIndispoOn + "h à " + plageIndispoOff + "h - heureOn : " + heureOn + "h - heureOff : " + heureOff + "h");
            //console.log("test heure off et on : " + (heureOff <= plageIndispoOn || heureOn >= plageIndispoOff));
            return (heureOff <= plageIndispoOn || heureOn >= plageIndispoOff);
          });
        }
      }
      //console.log("slots filtrés :\n", slots);
      return slots;

    } else {
      //console.log("pas de plages indispos pour " + jourFr);
      return slots;
    }
  }

  slotsInit = (momentTested) => {
    if (!momentTested) return [];

    const deliverySlotsAvailables = this.removePlagesIndispos(momentTested, deliverySlotsArray);

    if (momentTested.format(formatDeliveryDate) === moment().format(formatDeliveryDate)) {
      const verifTime = moment().add(returnHourDelay, 'hours');
      return deliverySlotsAvailables.filter(slot => {
        return (parseFloat(slot.Fr.split('-')[0].replace('h', '.').trim(), 10) > parseFloat(verifTime.format('HH.mm'), 10))
      });

    } else if (momentTested.diff(moment()) > 0) return deliverySlotsAvailables;

    else return [];
  }

  customSelectHandleClick = (e) => {
    if (e.cancelable) e.preventDefault();
    e.stopPropagation();
    let value = this.state.returnSlots[0][this.state.language]
    e.target.nextSibling.classList.toggle("select-hide")
    e.target.classList.toggle("select-arrow-active")
    if (document.querySelector('.same-as-selected')) value = document.querySelector('.same-as-selected').innerText
    e.target.innerText = value
  }

  customOptionHandleClick = (e) => {
    if (e.cancelable) e.preventDefault();
    e.stopPropagation();
    document.querySelector(".select-selected").innerText = e.target.innerText
    if (document.querySelector(".same-as-selected")) document.querySelector(".same-as-selected").classList.remove("same-as-selected");
    e.target.classList.add("same-as-selected")
    document.querySelector(".select-items").classList.add("select-hide")
    document.querySelector(".select-selected").classList.remove("select-arrow-active")
    //console.log(e.target.id)
    this.handleDateChange(e.target.innerText, 0);
  }

  customSelectHostHandleClick = (e) => {
    if (e.cancelable) e.preventDefault();
    e.stopPropagation();
    let value = this.state.currentContent.command+" 1: "+this.state.commands[0].host + (this.state.commands[0].retour? " (retour déjà planifié)" : "");
    e.target.nextSibling.classList.toggle("select-hide");
    e.target.classList.toggle("select-arrow-active");
    if (document.querySelector('#popup2 .same-as-selected')) value = document.querySelector('#popup2 .same-as-selected').innerText;
    e.target.innerText = value;
  }

  customOptionHostHandleClick = (e) => {
    if (e.cancelable) e.preventDefault();
    //console.log("customOptionHostHandleClick => selected : ", +e.target.id.replace("host", ""));

    this.setState({selectedCommand: +e.target.id.replace("host", "")});
    document.querySelector("#popup2 .select-selected").innerText = e.target.innerText;
    if (document.querySelector("#popup2 .same-as-selected")) document.querySelector("#popup2 .same-as-selected").classList.remove("same-as-selected");
    e.target.classList.add("same-as-selected");
    document.querySelector("#popup2 .select-items").classList.add("select-hide");
    document.querySelector("#popup2 .select-selected").classList.remove("select-arrow-active");
  }

  garderHandleClick = (e, id) => {
    if (!e.target.classList.contains('selected')){

      if (e.target.parentElement.querySelector('.selected')) e.target.parentElement.querySelector('.selected').classList.remove('selected');
      e.target.classList.add('selected');

      let keepedProduct = this.state.keepedProduct;
      if(keepedProduct.indexOf(id) === -1) keepedProduct.push(id);

      let returnedProduct = this.state.steps.returnedProduct.rep;
      if (returnedProduct.length > 0) returnedProduct = returnedProduct.filter(element => element.id !== id);
      let exchangeProduct = this.state.steps.exchangeProduct.rep.filter(element => element !== id);

      const products = [...this.state.produits];
      const indexProduct = products.findIndex(art => art.id === id);
      const indexRef = JSON.parse(sessionStorage.getItem('produitsRef')).findIndex(art => art.id === id);
      products[indexProduct].quantity = JSON.parse(sessionStorage.getItem('produitsRef'))[indexRef].quantity;

      this.saveChoiceProduct(keepedProduct, returnedProduct, exchangeProduct);
    }
  }

  rendreHandleClick = (e, product) => {
    if (!e.target.classList.contains('selected')) {
      if (e.target.parentElement.querySelector('.selected')) e.target.parentElement.querySelector('.selected').classList.remove('selected');
      e.target.classList.add('selected');

      let returnedProduct = this.state.steps.returnedProduct.rep;
      const indexRef = JSON.parse(sessionStorage.getItem('produitsRef')).findIndex(returned => returned.id === product.id);
      if (returnedProduct.findIndex(returned => returned.id === product.id) === -1) {
        returnedProduct.push({id: product.id, quantity: JSON.parse(sessionStorage.getItem('produitsRef'))[indexRef].quantity});
        product.quantity = JSON.parse(sessionStorage.getItem('produitsRef'))[indexRef].quantity;
      }
      let keepedProduct = this.state.keepedProduct.filter(element => element !== product.id);
      let exchangeProduct = this.state.steps.exchangeProduct.rep.filter(element => element !== product.id);

      this.saveChoiceProduct(keepedProduct, returnedProduct, exchangeProduct);
    }
  }

  echangerHandleClick = (e, product) => {
    if (!e.target.classList.contains('selected')) {
      if (e.target.parentElement.querySelector('.selected')) e.target.parentElement.querySelector('.selected').classList.remove('selected');
      e.target.classList.add('selected');

      let exchangeProduct = this.state.steps.exchangeProduct.rep;
      if (exchangeProduct.indexOf(product.id) === -1) exchangeProduct.push(product.id);

      let returnedProduct = this.state.steps.returnedProduct.rep;
      const indexRef = JSON.parse(sessionStorage.getItem('produitsRef')).findIndex(returned => returned.id === product.id);
      if (returnedProduct.findIndex(returned => returned.id === product.id) === -1) {
        returnedProduct.push({id: product.id, quantity: JSON.parse(sessionStorage.getItem('produitsRef'))[indexRef].quantity});
        product.quantity = JSON.parse(sessionStorage.getItem('produitsRef'))[indexRef].quantity;
      }
      let keepedProduct = this.state.keepedProduct.filter(element => element !== product.id);

      this.saveChoiceProduct(keepedProduct, returnedProduct, exchangeProduct);
    }
  }

  saveChoiceProduct(keepedProduct, returnedProduct, exchangeProduct) {
    //console.log("keepedProduct",keepedProduct); //console.log("returnedProduct",returnedProduct); //console.log("exchangeProduct",exchangeProduct)

    this.setState({
      keepedProduct: keepedProduct,
      steps: {...this.state.steps, returnedProduct: {...this.state.steps.returnedProduct, rep: returnedProduct}, exchangeProduct: {...this.state.steps.exchangeProduct, rep: exchangeProduct, errMsg:null}}
    })
  }

  changeLanguage = (lg)=> {
    this.setState({language : lg}, () => {
      const currentContent = content[lg];
      this.setState({ currentContent: currentContent })
    });
  }

  handleChangeExchangeInfos = (e) => {
    //console.log(e.target.value);
    this.setState({
      steps: {...this.state.steps, exchangeProduct: {...this.state.steps.exchangeProduct, infos: e.target.value}}
    });
  }

  checkIfInfos = () => {
    if(this.state.steps.exchangeProduct.infos) this.closePopup();
    else {
      this.infosAreaTxt.placeholder = "Champs obligatoire";
      this.infosAreaTxt.style.borderColor = "red";
      this.infosAreaTxt.focus();
      //alert("Merci de nous indiquer ce que vous souhaiter échanger ;)");
    }
  }

  handleRepStatTry = (value) => {
    this.setState({repStatTry: value === "Oui" || value === "Yes"? "oui" : "non"}, () => {
      this.handleNext("end");
    });
  }

  changeQuantity = (ope, i) => {
    const produitsRef = JSON.parse(sessionStorage.getItem('produitsRef'));
    const articleRef = {...produitsRef[i]};
    let products = [...this.state.produits];
    const article = products[i];

    //console.log("Article quantité : " + article.quantity + " - Ref quantité : " + articleRef.quantity);

    let returnedProduct = this.state.steps.returnedProduct.rep;
    let keepedProduct = this.state.keepedProduct;
    let exchangeProduct = this.state.steps.exchangeProduct.rep;

    // ajout ou suppression
    if (ope === "-") article.quantity--;
    else if (ope === "+") article.quantity++;

    // ajustement quantité
    if (article.quantity > articleRef.quantity) article.quantity = articleRef.quantity;
    else if (article.quantity < 1) article.quantity = 1;

    const artIndex = returnedProduct.findIndex(returned => returned.id === article.id);
    returnedProduct[artIndex] = {id: article.id, quantity: article.quantity};

    if (article.quantity < articleRef.quantity) {
      if (keepedProduct.findIndex(idKeeped => idKeeped === article.id) === -1) keepedProduct.push(article.id);
    } else if (article.quantity === articleRef.quantity) {
      keepedProduct = keepedProduct.filter(idKeeped => idKeeped !== article.id);
    }

    this.setState({produits: [...products]}, () => {
      this.saveChoiceProduct(keepedProduct, returnedProduct, exchangeProduct);
    });
  }

  btnDivJourHandleClick = (e) => {
    const deliverySelected = deliveryDaysArray.find(days => days.date === e.target.id);
    //console.log("date sélectionnée : " + deliverySelected.date, deliverySelected);

    this.setState({selectedDay: deliverySelected.date, returnSlots: this.slotsInit(deliverySelected.moment)});
    this.handleDateChange(deliverySelected.slots[0][this.state.language], 0); // 1er slot auto sélectionné
  }

  returnDate = (date) => {
    const momentNow = moment();

    if (momentNow.format("DD-MM-YYYY") === date) return lang === "FR"? "aujourd'hui" : "today";
    else if (momentNow.add(1, 'd').format("DD-MM-YYYY") === date) return lang === "FR"? "demain" : "tomorrow";
    else return (lang === "FR"? "le " : "on ") + date.replace(/-/g, "/");
  }


  render() {
    const state = this.state;

    return (
      <div className="formContainer d-flex flex-column" style={{ paddingBottom: 100, paddingTop: 60 }}>

        <nav className="navbar navbar-expand-lg navbar-light bg-light rounded staticknav">
          <div className="nav-item dropdown">
            <div className="nav-link dropdown-toggle" id="dropdown09" data-toggle="dropdown" aria-haspopup="true" style ={{cursor:'pointer'}} aria-expanded="false">
              <span className={state.language==='En'? "flag-icon flag-icon-us" :"flag-icon flag-icon-fr" }></span> {this.state.language}
            </div>
            <div className="dropdown-menu" aria-labelledby="dropdown09">
              {state.language==='En' && <div className="dropdown-item"  style ={{cursor:'pointer'}} onClick={e => this.changeLanguage('Fr')}><span className="flag-icon flag-icon-fr"> </span> Fr</div>}
              {state.language==='Fr' && <div className="dropdown-item"  style ={{cursor:'pointer'}} onClick={e => this.changeLanguage('En')}><span className="flag-icon flag-icon-us"> </span> En</div>}
            </div>
          </div>
        </nav>

        <div className="form">

          { /* affichage du premier screen */}
          {state.enableForm && state.stepNum === "start" && (<div className="startScreen screen">
            <img className="startImg" src="./newLogo.png" alt="logo"/>
            <br></br>
            <h3 className="quest">{state.currentContent.startText}</h3>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <input className="input" type="text" value={state.mailChange} onChange={e => this.setState({mailChange: e.target.value.replace(/ /g, "")})} placeholder={state.currentContent.placeHolder.email} />
            </div>
            {state.loading &&
              <span className="info">{state.currentContent.loading}</span>
            }
            {state.steps.email.errMsg &&
              <span className="error">{state.steps.email.errMsg}</span>
            }

            <div className="takAlldDiv">
              <button className="takeALL btn" onMouseOver={(e) => this.handleBtnMouseOn("all")} onMouseOut={(e) => this.handleBtnMouseOut("all")} onClick={(e) => this.handleTakeAll(true, 'open')} disabled={state.loading}>{state.currentContent.takeAll} <i style={{ right: '10px' }} className="fas fa-arrow-right all"></i></button>
              <button className="notTakeAll btn" onMouseOver={(e) => this.handleBtnMouseOn(e)} onMouseOut={(e) => this.handleBtnMouseOut(e)} onClick={(e) => this.handleTakeAll(false, null)} disabled={state.loading}>{state.currentContent.notTakeAll} <i style={{ right: '10px' }} className="fas fa-arrow-right notall"></i></button>

              <button className="contact btn disabled-btn" onClick={(e) => this.handleContactUs()} disabled={state.loading}>{state.currentContent.mailContact}</button>
            </div>

          </div>)}

          { /* returnedProduct ///////////////////////////////////////////////*/}
          {state.enableForm && state.stepNum === "returnedProduct" && (<div>
            <h3 className="quest">{1}- {state.currentContent.steps.returnedProduct.quest}</h3>
            <div className="cabine">
              {this.state.produits.map((article,i) => {
                  return(
                    <div id={"art" + i} className="article" key={"art" + i}>
                      <div className="artcileImgDetails">
                        <img className="articleImg" src={article.image} alt={article.name}/>
                        <div className='articleDetails'>
                          {article.name && <span><b>{article.name}</b><br></br><br></br></span>}
                          {article.color && <span><b>{state.currentContent.color}:</b> {article.color}<br></br></span>}
                          {article.size && <span><b>{state.currentContent.taille}:</b> {article.size}<br></br></span>}
                          {article.options2 && article.options2.map(option => <span><b>{option.nom}:</b> {option.value}<br></br></span>)}

                          {!state.shopify_mode && article.price && <span><b>{state.currentContent.prix}:</b> {article.price} €<br></br></span>}

                          {state.shopify_mode && <span><b>{state.currentContent.prix}:</b> {state.steps.returnedProduct.rep.findIndex(returned => returned.id === article.id) === -1 && JSON.parse(sessionStorage.getItem('produitsRef'))[i].quantity > 1? `${JSON.parse(sessionStorage.getItem('produitsRef'))[i].quantity} x ` : ''}{article.priceProduct} €<br></br></span>}

                          {state.shopify_mode && JSON.parse(sessionStorage.getItem('produitsRef'))[i].quantity > 1 && state.steps.returnedProduct.rep.findIndex(returned => returned.id === article.id) !== -1 && <span style={{display: 'flex', flexWrap: 'wrap'}}>
                            <b style={{whiteSpace: 'nowrap'}}>{state.currentContent.quantity}:</b>
                            <span style={{display: 'flex', alignItems: 'center', marginLeft: 5}}>
                              <button disabled={article.quantity === 1} className="btns_quantity" onClick={e => this.changeQuantity("-", i)}>-</button>
                              <span style={{margin: '0 2px', pointerEvents: 'none', border: '1px solid #AAA', padding: '0 6px'}}>{article.quantity}</span>
                              <button disabled={article.quantity === JSON.parse(sessionStorage.getItem('produitsRef'))[i].quantity} className="btns_quantity" onClick={e => this.changeQuantity("+", i)}>+</button>
                            </span>
                            <span style={{marginLeft: 5}}> / {JSON.parse(sessionStorage.getItem('produitsRef'))[i].quantity}</span>
                          </span>}

                        </div>
                      </div>
                      <div className="articleBtns">
                        <span onClick={e => this.garderHandleClick(e, article.id)} className='garderBtn'>{state.currentContent.garder}</span>
                        <span onClick={e => this.rendreHandleClick(e, article)} className='rendreBtn'>{state.currentContent.rendre}</span>
                        {/* <span onClick={e => this.echangerHandleClick(e, article)} className='echangerBtn'>{state.currentContent.echanger}</span> */}
                      </div>
                    </div>
                  )
                })}
            </div>

            {(state.steps.exchangeProduct.infos && state.steps.exchangeProduct.rep.length > 0) && <div className="infos-for-exchange" onClick={()=>this.setState({selectedPopup: 3})}>
              {state.currentContent.steps.returnedProduct.infosExchange} {state.steps.exchangeProduct.infos}
            </div>}

            {state.steps.returnedProduct.errMsg && <span className="error">{state.steps.returnedProduct.errMsg}</span>}

            <button className="btn" style={{ marginTop: '20px', width: '100%' }} onMouseOver={(e) => this.handleBtnMouseOn(e)} onMouseOut={(e) => this.handleBtnMouseOut(e)} onClick={(e) => this.returnedProductNextScreen()} disabled={this.returnNumOfProductsRep() !== state.produits.length}>{state.currentContent.suivant} <i style={{ right: '10px' }} className="fas fa-arrow-right notall"></i></button>

          </div>)}

          { /* heure ///////////////////////////////////////////////////*/}
          {state.enableForm && state.stepNum === "heure" && (<div>

            <h3 className="quest">{2}- {state.currentContent.steps.heure.quest}</h3>

            <div className="returnDays" style={{width: '100%', display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', marginTop: 32}}>
              {deliveryDaysArray.map((obj, i) => {

                const divJour = <div id={obj.date} className={state.selectedDay === obj.date ? 'divJour selectJour' : 'divJour'}
                onClick={e => {
                  this.btnDivJourHandleClick(e);
                }}>{obj.label}</div>;

                return (<div key={i}>{divJour}</div>);
              })}
            </div>

            {state.returnSlots && state.returnSlots.length && <div className="custom-selection">
              <div className="select-selected select"
                onClick={(e) => { this.customSelectHandleClick(e) }}>
                {this.state.returnSlots[0][this.state.language]}
              </div>
              <div className="select-items select-hide">
                {this.state.returnSlots.map((slot, i) => {
                  return (
                    <div id={"slot" + i} key={"slot" + i} className="divOptionPlage"
                      onClick={(e) => { this.customOptionHandleClick(e) }}>{slot[this.state.language]}</div>
                  )
                })}
              </div>
            </div>}

            {(!state.returnSlots || state.returnSlots.length === 0) && <p>{state.currentContent.noMoreSlot}</p>}

            {state.steps.heure.errMsg &&
              <span className="error">{state.steps.heure.errMsg}</span>
            }

            <h3 className="quest" style={{marginTop: 40}}>{3}- {state.currentContent.steps.adresse.quest}</h3>
            <PlacesAutocomplete
              value={state.adresseChange.replace('null','') || ''}
              onChange={value => {
                autoSuggGoogleMaps = true;
                villeTest = false;
                this.handleAdresseChange(value);
              }}
              onSelect={value => {
                autoSuggGoogleMaps = false;
                this.handleAdresseChange(value);
              }}
              searchOptions={searchOptions}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div className="" style={{ position: 'relative',backgroundColor:"white" }}>
                  <input
                  style={{marginBottom :'0px'}}
                    {...getInputProps({
                      placeholder: 'Entrez une adresse pour le retour.. *',
                      className: 'location-search-input',
                    })}
                    id="adressInput"
                    onFocus={() => autoSuggGoogleMaps = true}
                    onBlur={(evt) => {
                      autoSuggGoogleMaps = false;
                      this.handleAdresseChange(evt.target.value);
                    }}
                    name="address" />
                  {autoSuggGoogleMaps && <div className="autocomplete-dropdown-container">
                    {loading && <div>{state.currentContent.loading}...</div>}
                    {suggestions.map(suggestion => {
                      const className = suggestion.active
                        ? 'suggestion-item--active ListItem'
                        : 'suggestion-item ListItem';
                      return (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            className,
                          })}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}
                  </div>}
                </div>
              )}
            </PlacesAutocomplete>

            {state.steps.adresse.errMsg &&
              <span className="error">{state.steps.adresse.errMsg}</span>
            }

            <div style={{ display: 'flex', flexDirection: 'row', marginTop:'25px' }}>
              <input className="input" type="text" value={state.complement? state.complement : ""} onChange={(e) => this.setState({ complement: e.target.value })} placeholder={window.innerWidth > 900 ? state.currentContent.placeHolder.complement.desktop :state.currentContent.placeHolder.complement.mobile } />
            </div>

            <button className="btn" style={{marginTop: 20, width: '100%'}} onMouseOver={(e) => this.handleBtnMouseOn(e)} onMouseOut={(e) => this.handleBtnMouseOut(e)} onClick={(e) => this.handleNext("statTry")} disabled={!state.steps.adresse.rep}>{state.currentContent.suivant} <i style={{ right: '10px' }} className="fas fa-arrow-right notall"></i></button>

          </div>)}

          { /* statTry ///////////////////////////////////////////////////*/}
          {state.enableForm && state.stepNum === "statTry" && (<div>

            <h3 className="quest">{4}- {state.currentContent.steps.statTry.quest}</h3>

            <div className="div-btns-statTry">
              {state.currentContent.steps.statTry.btns.map((value, index) => {
                return (
                  <button key={"rep" + index} className={state.repStatTry === value? "btns-statTry selected" : "btns-statTry"} onClick={(e) => this.handleRepStatTry(value)}>{value}</button>
                )
              })}
            </div>

            <button className="btn" style={{marginTop:'20px', width: '100%'}} onMouseOver={(e) => this.handleBtnMouseOn(e)} onMouseOut={(e) => this.handleBtnMouseOut(e)} onClick={(e) => this.handleNext("end")}>{state.currentContent.passer} <i style={{ right: '10px' }} className="fas fa-arrow-right notall"></i></button>

          </div>)}

          { /* affichage du dernier ecran */}
          {state.stepNum === "end" && (<div className="endScreen screen">

            <img className="endImg" src="https://images.typeform.com/images/QCNfiC82qxKG/image/default" alt="Merci Gustave"/>

            <h3 className="quest">{state.currentContent.endText.text1}</h3>

            {state.selectedDay && state.steps.adresse.rep &&
            <p>{state.currentContent.endText.text2.part1.split("*")[0]} {this.returnDate(state.selectedDay)} {state.currentContent.endText.text2.part1.split("*")[1]} {plageSelect.split('-')[0].trim()} {state.currentContent.endText.text2.part2} {plageSelect.split('-')[1].trim()} {state.currentContent.endText.text2.part3} {state.steps.adresse.rep}</p>
            }

            <div className="endDiv">
              <p>{state.currentContent.endText.text3} <br></br><a href="https://www.mercigustave.co/#partenaires">mercigustave.co</a> !</p>
            </div>

          </div>)}

          { /* affichage du popup de rating/validation */}
          {state.enableForm && (<div id="popup1" className="overlay">
            <div className="popup">
              <div className="close" onClick={() => this.setState({selectedPopup: null, counter: this.countRep(state.stepNum, state.takeAll, null)})}>&times;</div>
              <div className="content">
              <p>{state.currentContent.popUp.text}</p>
                <Rating
                  className="rating"
                  initialRating={this.state.note}
                  emptySymbol="far fa-star fa-3x"
                  fullSymbol="fas fa-star fa-3x"
                  onChange={(e)=>this.handleRateChange(e)}
                />
                <div style={{justifyContent:'center', display:'flex', marginTop:"50px"}}>
                  <input type="text" className="remarque" width="40%" onChange={(e) => { this.setState({ remarque: e.target.value }) }} placeholder={window.innerWidth > 900 ? state.currentContent.placeHolder.remarque.desktop : state.currentContent.placeHolder.remarque.mobile}></input>
                </div>
                  { /* affichage de l'erreur de saisie */}
                {state.stepNum === "start" && state.steps.note.errMsg &&
                  <span className="error">{state.steps.note.errMsg}</span>
                }
                {state.stepNum === "start" && state.steps.email.errMsg &&
                  <span className="error">{state.steps.email.errMsg}</span>
                }
                {state.stepNum === "start" && state.steps.returnedProduct.errMsg &&
                  <span className="error">{state.steps.returnedProduct.errMsg}</span>
                }
                {state.stepNum === "start" && state.steps.heure.errMsg &&
                  <span className="error">{state.steps.heure.errMsg}</span>
                }
                {state.stepNum === "start" && state.steps.adresse.errMsg &&
                  <span className="error">{state.steps.adresse.errMsg}</span>
                }
                {state.stepNum === "start" && state.steps.takeall.errMsg &&
                  <span className="error">{state.steps.takeall.errMsg}</span>
                }
                <br/>

                <button className="btn validate" onClick={this.handleValidation} disabled={!this.state.note}>{state.currentContent.valider}</button>
              </div>
            </div>
          </div>)}

          { /* affichage du popup de choix de commande */}
          {state.enableForm && (<div id="popup2" className="overlay">
            <div className="popup">
              <div className="close" onClick={() => {
                let updateState = {selectedPopup: null};
                if(state.loading) updateState.loading = false;
                this.setState(updateState);
              }}>&times;</div>
              <div className="content">
                <p>{state.currentContent.popUp2.text}</p>
                {state.commands && state.commands.length > 1 &&
                  <div className="custom-selection" >
                  <div style={{textAlign:'left'}} className="select-selected select"
                    onClick={(e) => { this.customSelectHostHandleClick(e) }}>
                  {state.selectedCommand+1}{state.commands[state.selectedCommand].lang === "FR"? " :" : ":" } {state.currentContent.command} N° {state.commands[state.selectedCommand].orderId} - {state.commands[state.selectedCommand].host}
                  </div>
                  <div className="select-items select-hide">
                    {state.commands.map((slot, i) => {
                      return (
                        <div key={i} id={"host" + i} className="divOptionPlage" onClick={e => this.customOptionHostHandleClick(e)}>
                          {i+1}{slot.lang === "FR"? " :" : ":" } N° {slot.orderId} - {slot.host}
                        </div>
                      )
                    })}
                  </div>

                  {state.steps.email.errMsg && <span className="error">{state.steps.email.errMsg}</span>}
                  </div>
                }
                <button className="btn validate validCommandList" onClick={(e) => {
                    sessionStorage.setItem('produitsRef', JSON.stringify(this.state.commands[state.selectedCommand].data.filter(article => article.status !== false)));
                    this.updateForm(this.state.commands[state.selectedCommand]);
                  }}>{state.currentContent.valider}</button>
              </div>
            </div>
          </div>)}

          { /* affichage du popup si échange d'article */}
          {state.enableForm && (<div id="popup3" className="overlay">
            <div className="popup">
              <div className="close" onClick={() => this.setState({selectedPopup: null})}>&times;</div>
              <div className="content">
                <p className="exchange-title">{state.currentContent.popUp3.titre}</p>
                <p className="exchange-txt">{state.currentContent.popUp3.text1}</p>
                <textarea id="infosTxt" className="exchange-infos" ref={input => this.infosAreaTxt = input} value={this.state.steps.exchangeProduct.infos} onChange={this.handleChangeExchangeInfos} cols={40} rows={3} />
                <p className="exchange-txt">{state.currentContent.popUp3.text2}</p>
                <p className="exchange-txt">{state.currentContent.popUp3.text3}</p>
                <button className="btn validate" onClick={() => {
                    this.checkIfInfos();
                  }}>{state.currentContent.popUp3.button}</button>
              </div>
            </div>
          </div>)}

        </div>

        <div className="footBar">
          <div className="progressDiv">
            {state.counter > 0 && <span>{state.counter} {state.currentContent.progressBar.text2}{state.counter>1?'s':''} {state.currentContent.progressBar.text1} {state.totalQuestions} </span>}
            <ProgressBar className="ProgressBar" now={(state.counter? (state.counter * 100 / state.totalQuestions) : 0)} />
          </div>

          {state.enableForm && (<div className="updDownDiv">
            <span className="prev" onClick={e => this.handlePreviousStep(e)}><i className="fas fa-chevron-left"></i></span>
            <span className="next" onClick={e => this.handleNextStep(e)}><i className="fas fa-chevron-right"></i></span>
          </div>)}
        </div>

      </div>
    );
  }
}

export default Form;
